// CaseStudies.jsx
import React from 'react';
import Seo from '../../components/Seo/Seo';
import CaseStudyListingHeader from '../../components/CaseStudies/CaseStudyListingHeader';
import CaseStudyListing from '../../components/CaseStudies/CaseStudyListing';
import { caseStudies, branches } from '../../content/case-studies';

const CaseStudies = () => {
  return (
    <>
      <Seo
        title="Case Studies & Branchenlösungen | Nexite IT"
        description="Digitale Lösungen für Handwerk, Steuerberatung und weitere Branchen: Unsere Case Studies zeigen, wie wir Websites und Anwendungen für den Mittelstand umsetzen."
        path="/case-studies"
      />
      <CaseStudyListingHeader />
      <CaseStudyListing branches={branches} posts={caseStudies} />
    </>
  );
};

export default CaseStudies;
